import find from 'lodash/find';
import first from 'lodash/first';
import sortBy from 'lodash/sortBy';

export const findClosestMsrp = (options, msrp) => {
  const exactMatch = find(options, { msrp });
  if (exactMatch) {
    return exactMatch;
  }
  return first(sortBy(options, (x) => Math.abs(x.msrp - msrp)));
};
